module.exports = __webpack_public_path__ + "static/media/BGP-CTI.b36b0d66.jpg";